@if (visible()) {
    <div
        class="mt-2 w-full rounded-lg border border-solid border-[#bfdbfe] shadow-[0_4px_8px_rgba(2,5,10,0.04)] bp908:max-w-[222px]">
        <div
            class="flex items-start gap-[7px] rounded-[7px] bg-[#dbeafe] px-[10.5px] py-[7px] shadow-[0_4px_4px_rgba(2,5,10,0.04)]">
            <p
                class="m-0 min-w-0 flex-1 font-inter text-[14px] font-medium leading-normal text-[#2563eb]">
                You may match with people in Quiet Mode. You can change this in your
                <a
                    [routerLink]="['/settings']"
                    [queryParams]="{
                        type: 'preferences',
                        focus: 'quietModeMatch',
                    }"
                    class="font-medium underline decoration-solid underline-offset-2 hover:opacity-90"
                    >Settings</a
                >.
            </p>
            <button
                type="button"
                class="flex size-[24.5px] shrink-0 cursor-pointer items-center justify-center rounded-[12.25px] border-0 bg-transparent text-[#2563eb]"
                aria-label="Dismiss quiet mode message"
                (click)="dismiss()">
                <i class="pi pi-times block text-[14px] leading-none"></i>
            </button>
        </div>
    </div>
}
